import { InitFeatureParams } from '../types'

import { getRoutes, modalRoutes } from './routes'

/**
 * 初始化-门户管理-用户
 *
 * @param param - 参数
 * @param param.addRoutes - 添加路由
 */
export const initGateway = ({ addRoutes }: InitFeatureParams) => {
  addRoutes(getRoutes(), modalRoutes)
}
